import React from 'react';
import { Box, Stepper, Step, StepLabel, StepConnector, styled } from '@mui/material';
import { useCheckout } from '../../contexts/CheckoutContext';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaymentIcon from '@mui/icons-material/Payment';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import StepIcon from '@mui/material/StepIcon';

// Custom styled connector for the stepper
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.MuiStepConnector-alternativeLabel`]: {
    top: 22,
  },
  [`&.MuiStepConnector-active`]: {
    [`& .MuiStepConnector-line`]: {
      backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
    },
  },
  [`&.MuiStepConnector-completed`]: {
    [`& .MuiStepConnector-line`]: {
      backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
    },
  },
  [`& .MuiStepConnector-line`]: {
    height: 3,
    border: 0,
    backgroundColor: theme.palette.grey[300],
    borderRadius: 1,
  },
}));

// Custom step icon component
const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.grey[300],
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage: `linear-gradient(to right, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
  }),
}));

// Custom icon wrapper to handle icon display
const StepIconComponent = (props) => {
  const { active, completed, className, icon } = props;

  const icons = {
    1: <LocationOnIcon />,
    2: <PaymentIcon />,
    3: <DescriptionIcon />,
    4: <CheckCircleIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ active, completed }} className={className}>
      {icons[String(icon)]}
    </ColorlibStepIconRoot>
  );
};

// Step labels for the checkout process
const steps = ['Location', 'Payment', 'Details', 'Confirmation'];

/**
 * Checkout Stepper Component
 * Displays the progress of the checkout process using Material UI Stepper
 */
const CheckoutStepper = () => {
  const { currentStep } = useCheckout();

  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <Stepper 
        alternativeLabel 
        activeStep={currentStep} 
        connector={<ColorlibConnector />}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel StepIconComponent={StepIconComponent}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CheckoutStepper;